import { Box } from '@mui/material';
import { ReactElement, type ComponentType, type ReactNode } from 'react';
import { Form, ResourceContextProvider } from 'react-admin';
import { getPeriodDateRange, startOfMonth, today } from './utils';

interface ReportWidgetProps {
  resource: string;
  filters: ComponentType[];
  actions: ReactNode;
  defaultValues?: Record<string, unknown>;
}

const filterDefaultValues = {
  greaterOrEqual: { date: startOfMonth },
  lessOrEqual: { date: today },
};

export default function ReportWidget({
  resource,
  filters,
  actions,
  defaultValues,
}: ReportWidgetProps): ReactElement {
  const defaultPeriod =
    typeof defaultValues?.period === 'string' ? defaultValues.period : undefined;
  const defaultPeriodRange = getPeriodDateRange(defaultPeriod);

  return (
    <ResourceContextProvider value={resource}>
      <Box
        sx={{
          '& .MuiFormHelperText-root': {
            minHeight: 0,
            lineHeight: 0,
          },
        }}
      >
        <Form
          defaultValues={{
            ...filterDefaultValues,
            ...(defaultPeriodRange
              ? {
                  greaterOrEqual: { date: defaultPeriodRange.from },
                  lessOrEqual: { date: defaultPeriodRange.to },
                }
              : {}),
            ...defaultValues,
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'nowrap' }}>
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                flexWrap: 'wrap',
                gap: 2,
                flex: 1,
              }}
            >
              {filters.map((Filter, index) => (
                <Box key={index} sx={{ width: 210, '& .MuiFormControl-root': { width: '100%' } }}>
                  <Filter />
                </Box>
              ))}
            </Box>
            <Box component="span" sx={{ flexShrink: 0, display: 'flex', gap: 1 }}>
              {actions}
            </Box>
          </Box>
        </Form>
      </Box>
    </ResourceContextProvider>
  );
}
